import { render, staticRenderFns } from "./AlertTrendChart.vue?vue&type=template&id=0f66bc2f&scoped=true&"
import script from "./AlertTrendChart.vue?vue&type=script&lang=js&"
export * from "./AlertTrendChart.vue?vue&type=script&lang=js&"
import style0 from "./AlertTrendChart.vue?vue&type=style&index=0&id=0f66bc2f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f66bc2f",
  null
  
)

export default component.exports